
<script>
import { defineComponent, inject } from 'vue'
import { useRoute } from 'vue-router'
import ParallaxImage from '@kit/components/ParallaxImage.vue'
import Column from '@kit/components/Column.vue'
import { getCurrentYear, cmsasset } from '@kit/utils/Formats'
import "@css/index.css";

export default defineComponent({
  name: "Footer",

  setup() {

    const route = useRoute()
    const hydrate = inject("hydrate")

    const { prefetch } = hydrate({
      prefetch:["common"],
    })

    return { prefetch, getCurrentYear, cmsasset }

  },

  components: {
    ParallaxImage,
    Column
  }

});
</script>

<template>

  <footer id="visit">
    <!-- <div class="wrap">
      <p>© {{ getCurrentYear() }} Treasure Coast Avionics, Inc · FAA Part 145 Certified Repair Station</p>
      <p>KFPR · Fort Pierce, Florida</p>
    </div> -->

    <div v-if="prefetch && prefetch.common" class="wrap">
      <div v-html="prefetch.common.footer_header" class="reveal in" style="transition-delay: 0ms;"></div>
      <div class="visit-grid" v-html="prefetch.common.footer_html"></div>
    </div>


  </footer>
  <!-- <div class="sb sb-v footer sb-gr">

    <Column tag="div" :ltS="100" :ltP="100" :ltT="100" :ltD="100" :gtB="1000" :gtH="1200" class="sb sb-v">

    </Column>
  </div> -->

</template>